export enum SubscriberTypeEnum {
    signatory = 0,
    witness = 1,
    authorizer = 2,
    responsible = 3
}
